import { useMutation, useQueryClient } from "@tanstack/react-query";
import { companyApi, companyQueryKeys } from "service/crm/api/company";
import { contactQueryKeys } from "../api/contact";

export const useLinkCompanyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: companyApi.linkCompanyToContact,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: companyQueryKeys.byContact(variables.contactUuid),
      });
      queryClient.invalidateQueries({
        queryKey: contactQueryKeys.activities(variables.contactUuid),
      });
    },
  });
};
